module.exports = __webpack_public_path__ + "img/1bc8996.svg";